var React = require('react');

function Gy (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"fill":"#399408","d":"M2.4 0H640v480H2.4z","key":0}),React.createElement("path",{"fill":"#fff","d":"M.2 0c-.9 0 619.6 241.5 619.6 241.5L0 479.8.2 0z","key":1}),React.createElement("path",{"fill":"#ffde08","d":"M.3 20.2c3.4 0 559 217.9 555.9 220L1.9 463.2.3 20.3z","key":2}),React.createElement("path",{"d":"M1.9.8c1.8 0 290.9 240.9 290.9 240.9L1.8 477V.8z","key":3}),React.createElement("path",{"fill":"#de2110","d":"M.3 33.9c1.6-15 260.9 208.4 260.9 208.4L.2 451.7V33.9z","key":4})]));
}

Gy.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Gy;

Gy.default = Gy;
